import { ThemeModule } from '../../front/lib/ThemeModule';
export class SharingButtons extends ThemeModule {
    init() {
        this.root.querySelectorAll('a[data-share-button-link]').forEach(el => {
            el.addEventListener('click', e => {
                e.preventDefault();
                const width = Math.max(300, window.innerWidth / 3);
                const height = Math.max(300, window.innerHeight / 2);
                window.open(el.dataset.shareButtonLink, 'newwindow', `width=${width},height=${height}`);
            });
        });
    }
}
